import { Injectable } from '@angular/core';
import { fromEvent, interval, merge, map, filter } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class SleepWatcherService {
  private last = Date.now();

  sleepEvents$ = merge(
    fromEvent(document, 'visibilitychange').pipe(
      filter(() => document.visibilityState === 'visible'),
      map(() => 'visible')
    ),
    fromEvent(window, 'online').pipe(map(() => 'online')),
    fromEvent(window, 'offline').pipe(map(() => 'offline')),
    interval(10000).pipe(
      filter(() => {
        const now = Date.now();
        const diff = now - this.last;
        this.last = now;
        return diff > 60000; // gap indicates sleep
      }),
      map(() => 'gap')
    )
  );
}